import React from "react";
import InfoBanner from "../../shared/components/infoBanner";
import Layout from "../../shared/components/layout";

function ExternalPayerRedirect() {
  return (
    <Layout
      banner={"Transfer Health Information"}
      header={"Your data transfer has started"}
    >
      <InfoBanner
        text={
          <>
            Your data is processing and will be ready in <b>24 to 48 hours.</b>
          </>
        }
      ></InfoBanner>
      <div>
        There should be some more updates to the information here but this is
        placeholder text for now.
      </div>
    </Layout>
  );
}

export default ExternalPayerRedirect;
